var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-flexbox', 'sw-flexbox--column', 'sw-flexbox--center-justify', 'sw-flexbox--center-items']},[_c('sw-spinning-progress',{attrs:{"size":'64px',"color":'#ff791a'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }